<template>
  <div class="pc-login" v-if="$store.state.login.isShow">
    <div class="login_box">
      <!-- 登录模块 -->
      <div class="sign_in" v-if="sign === 1">
        <i class="iconfont icon-guanbi" @click="close"></i>
        <h1>登录</h1>
        <el-form :model="signForm" :rules="signRules" ref="signForm">
          <el-form-item label="账号" prop="username">
            <el-input
              v-model.trim="signForm.username"
              placeholder="账号/手机号/邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              v-model.trim="signForm.password"
              :type="signIsPass ? 'text' : 'password'"
              @keyup.enter.native="signIn"
            ></el-input>
            <i
              :class="`iconfont ${
                signIsPass ? 'icon-icon_zhengyanjing_1' : 'icon-biyanjing'
              }`"
              @click="signIsPass = !signIsPass"
            ></i>
            <a href="javascript:;" @click="$store.commit('login/setSign', 3)"
              >忘记密码?</a
            >
          </el-form-item>
          <el-form-item>
            <el-button :loading="signLoding" @click="signIn">登录</el-button>
          </el-form-item>
        </el-form>
        <p>
          没有账号？
          <i @click="$store.commit('login/setSign', 2)">点击注册</i>
        </p>
        <div class="wx_login">
          <p @click="$store.commit('login/setSign', 5)">微信登录</p>
        </div>
      </div>

      <!-- 注册模块 -->
      <div class="register" v-else-if="sign === 2">
        <i class="iconfont icon-guanbi" @click="close"></i>
        <h1>注册 ChatAI</h1>
        <el-form :model="regForm" :rules="regRules" ref="regForm">
          <el-form-item label="账号" prop="username">
            <el-input
              v-model.trim="regForm.username"
              placeholder="长度限制为3-40位"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              v-model.trim="regForm.password"
              placeholder="长度限制为6-20位"
              :type="regIsPass ? 'text' : 'password'"
            ></el-input>
            <i
              :class="`iconfont ${
                regIsPass ? 'icon-icon_zhengyanjing_1' : 'icon-biyanjing'
              }`"
              @click="regIsPass = !regIsPass"
            ></i>
          </el-form-item>
          <el-form-item label="验证码" prop="captcha">
            <el-input v-model.trim="regForm.captcha"></el-input>
            <img :src="captcha.image" alt="" @click="getImaCode" />
            <p class="prompt">看不清楚？点击图形码换一张</p>
          </el-form-item>
          <el-form-item label="邀请码" v-show="false">
            <el-input
              v-model.trim="regForm.inviteCode"
              placeholder="可以为空"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button :loading="regLoading" @click="register">注册</el-button>
          </el-form-item>
        </el-form>
        <p>
          有账号？
          <i @click="$store.commit('login/setSign', 1)">点击登录</i>
        </p>
      </div>

      <!-- 找回密码模块 -->
      <div class="retrieve_password" v-else-if="sign === 3">
        <i class="iconfont icon-guanbi" @click="close"></i>
        <h1>找回密码</h1>
        <el-form :model="retForm" :rules="retRules" ref="retForm">
          <el-form-item label="手机/邮箱" prop="account">
            <el-input v-model.trim="retForm.account"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-input v-model.trim="retForm.code"></el-input>
            <i
              class="iconfont icon-fasong"
              title="发送验证码"
              v-if="!isCode"
              @click="getCode"
            ></i>
            <i v-else class="iconfont">{{ num }}s</i>
          </el-form-item>
          <el-form-item>
            <el-button @click="next">下一步</el-button>
          </el-form-item>
        </el-form>
        <p>
          有账号？
          <i @click="$store.commit('login/setSign', 1)">点击登录</i>
        </p>
      </div>

      <!-- 设置新密码 -->
      <div class="set_password" v-else-if="sign === 4">
        <i class="iconfont icon-guanbi" @click="close"></i>
        <h1>设置新密码</h1>
        <h3>账户名称:{{ setForm.username }}</h3>
        <el-form :model="setForm" :rules="setRules" ref="setForm">
          <el-form-item label="新密码" prop="password">
            <el-input
              v-model.trim="setForm.password"
              :type="setPassOne ? 'text' : 'password'"
            ></el-input>
            <i
              :class="`iconfont ${
                setPassOne ? 'icon-icon_zhengyanjing_1' : 'icon-biyanjing'
              }`"
              @click="setPassOne = !setPassOne"
            ></i>
          </el-form-item>
          <el-form-item label="确认密码" prop="ConfirmPassword">
            <el-input
              v-model.trim="setForm.ConfirmPassword"
              :type="setPassTwo ? 'text' : 'password'"
            ></el-input>
            <i
              :class="`iconfont ${
                setPassTwo ? 'icon-icon_zhengyanjing_1' : 'icon-biyanjing'
              }`"
              @click="setPassTwo = !setPassTwo"
            ></i>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetPass">确认</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 微信登录 -->
      <div class="wx_group" v-else>
        <i
          class="iconfont icon-xitongfanhui"
          @click="$store.commit('login/setSign', 1)"
        ></i>
        <h1>微信扫码登录</h1>
        <p>首次注册将自动生成账号密码</p>
        <wxlogin
          :self_redirect="'false'"
          :appid="'wxf03dc49bb0224967'"
          :scope="'snsapi_login'"
          :theme="'black'"
          :redirect_uri="redirectUri"
          href="data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKIGRpc3BsYXk6IG5vbmU7Cn0K"
        ></wxlogin>
      </div>

      <!-- 提示确认框 -->
      <div class="confirmation_box" v-if="isConfirmation">
        <div class="center">
          <h1>
            <img
              src="../../assets/pc_img/login_img/success icon.png"
              alt="success icon"
            />
            {{ messageTxt }}
          </h1>
          <el-button @click="confirm">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import wxlogin from 'vue-wxlogin'
import {
  chatRegister,
  chatLogin,
  chatUserInfo,
  chatCaptchaCode,
  chatResetPass,
  chatWxScanLogin,
  chatGetUserName,
  chatHelpCaptcha
} from '@/api/login'
export default {
  name: 'PCLogin',
  components: {
    wxlogin: () => import('vue-wxlogin')
  },
  computed: {
    ...mapState('login', ['sign', 'isShow']),
    ...mapState(['AllUserChatRecord', 'AllchatRecord', 'InvitationCode']),
    redirectUri () {
      return encodeURIComponent(
        `https://chat-gpt-ai.cn/wxpassport/get-weixin-code.html?appid=wxf03dc49bb0224967&scope=snsapi_login&state=chatgpt&redirect_uri=${
          window.location.href.split('#')[0]
        }`
      )
    }
  },
  data () {
    return {
      input: null,
      signIsPass: false,
      regIsPass: false,
      setPassOne: false,
      setPassTwo: false,
      // 登录数据
      signForm: {
        username: '', //  string   必需
        password: '' //  string   必需
      },
      signRules: {
        username: [
          { required: true, message: '请输入您的账号', trigger: 'blur' },
          { min: 3, max: 40, message: '账号长度为3-40位数', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入您的密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度为6-20位数', trigger: 'blur' }
        ]
      },
      // 注册数据
      regForm: {
        username: '', // string  用户名 必需
        password: '', // string  密码
        captcha: '', // 验证码
        inviteCode: '' // 邀请码
      },
      regRules: {
        username: [
          { required: true, message: '账号不能为空', trigger: 'blur' },
          { min: 3, max: 40, message: '账号长度为3-40位数', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度为6-20位数', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '图形码不能为空', trigger: 'blur' }
        ]
      },
      // 重置密码
      retForm: {
        account: '', //  string  账号 必需 邮箱或手机号
        code: '' //  string  验证码 必需
      },
      retRules: {
        account: [
          { required: true, message: '手机/邮箱不能为空', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const phoneReg =
                /^[1][3,4,5,6,7,8,9][0-9]{9}$/
              const emailReg =
                /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/
              if (value.indexOf('@') !== -1) {
                if (!emailReg.test(value)) {
                  callback(new Error('请填写正确的邮箱格式格式!'))
                } else {
                  callback()
                }
              } else {
                if (!phoneReg.test(value)) {
                  callback(new Error('请填写正确的手机号格式!'))
                } else {
                  callback()
                }
              }
            }
          }
        ],
        code: [{ required: true, message: '验证码不能为空', trigger: 'blur' }]
      },
      // 设置新密码
      setForm: {
        username: '', // 用户名称
        password: '', //  string  新密码
        ConfirmPassword: '' // string 确认密码
      },
      setRules: {
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度为6-20位数', trigger: 'blur' }
        ],
        ConfirmPassword: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度为6-20位数', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.setForm.password !== value) {
                callback(new Error('两次密码输入不一致'))
              } else {
                callback()
              }
            }
          }
        ]
      },
      // 是否已经发送了验证码
      isCode: false,
      // 倒计时数
      num: 59,
      // btnLoading
      signLoding: false,
      regLoading: false,
      // 提示框show
      isConfirmation: false,
      // 提示语
      messageTxt: '注册成功',
      // 图形码
      captcha: {}
    }
  },
  created () {
    // 如果有邀请码的话
    if (this.InvitationCode) {
      this.regForm.inviteCode = this.InvitationCode
    }
    // 获取扫码登录的code
    this.getlocation()
    // 获取注册图形码
    this.getImaCode()
  },
  methods: {
    // 关闭窗口
    close () {
      this.$store.commit('login/setIsShow', false)
    },
    // 登录
    signIn () {
      const { username, password } = this.signForm
      this.$refs.signForm.validate((valid) => {
        if (valid) {
          this.signLoding = true
          chatLogin({
            username,
            password,
            platform: 'pc'
          })
            .then((res) => {
              localStorage.setItem('token', res.data.token)
              this.$store.commit('setToken', res.data.token)
              this.$store.commit('login/setIsShow', false)
            })
            .catch(() => {})
            .finally(() => {
              this.signLoding = false
              if (this.$store.state.token) {
                // 获取用户信息
                this.getUserInfo()
              }
            })
        }
      })
    },
    // 注册
    register () {
      const { username, password } = this.regForm
      this.$refs.regForm.validate((valid) => {
        if (valid) {
          this.regLoading = true
          chatRegister({
            username,
            password,
            invite_code: this.regForm.inviteCode,
            channel: this.$store.state.cid,
            captcha_id: this.captcha.captcha_id,
            captcha_value: this.regForm.captcha,
            platform: 'pc'
          })
            .then((res) => {
              if (res.code === 200) {
                // window._baq.track('active_register', {
                //   assets_id: '1760881358383115'
                // })
                (function (w, n) {
                  w[n] = typeof w[n] === 'function'
                    ? w[n]
                    : function () {
                      (w[n].c = w[n].c || []).push(arguments)
                    }

                  window._qha('send', {
                    et: 31,
                    order: [{
                      id: username, /* 注册id, 必填项 */
                      orderType: '1'/* 常量，请勿修改 */
                    }]
                  })
                })(window, '_qha')
                this.messageTxt = '注册成功'
                this.isConfirmation = true
                this.signForm.username = username
                this.regForm = {
                  username: '', // string  用户名 必需
                  password: '', // string  密码
                  inviteCode: '' // 邀请码
                }
              }
            })
            .catch(() => {
              this.getImaCode()
            })
            .finally(() => {
              this.regLoading = false
            })
        }
      })
    },
    // 微信扫码登录
    wxLogin (code) {
      chatWxScanLogin({
        code,
        channel: this.$store.state.cid
      })
        .then((res) => {
          localStorage.setItem('token', res.data.token)
          this.$store.commit('setToken', res.data.token)
        })
        .catch(() => {})
        .finally(() => {
          this.signLoding = false
          if (this.$store.state.token) {
            // 获取用户信息
            this.getUserInfo()
          }
        })
    },
    // 获取用户信息
    async getUserInfo () {
      const res = await chatUserInfo()
      localStorage.setItem('userInfo', JSON.stringify(res.data))
      this.$store.commit('setUserInfo', res.data)
    },
    // 下一步
    next () {
      this.$refs.retForm.validate((valid) => {
        if (valid) {
          this.getUserName().then(() => {
            this.$store.commit('login/setSign', 4)
          })
        }
      })
    },
    // 获取验证码
    async getCode () {
      if (!this.retForm.account) return
      const res = await chatCaptchaCode({
        account: this.retForm.account,
        code_type: 1
      })
      if (res.code === 200) {
        this.$message({
          message: '发送成功，请注意查收',
          type: 'success'
        })
        // 开启倒计时
        this.countDown()
      }
    },
    // 获取图形码
    async getImaCode () {
      const res = await chatHelpCaptcha()
      this.captcha = res.data
    },
    // 重置密码
    async resetPass () {
      this.$refs.setForm.validate(async (valid) => {
        if (valid) {
          const res = await chatResetPass({
            account: this.retForm.account, // string  账号 必需 邮箱或手机号
            code: this.retForm.code, // string  验证码 必需
            password: this.setForm.password // string  新密码 必需
          })
          if (res.code === 200) {
            this.messageTxt = '密码修改成功'
            this.isConfirmation = true
            this.retForm = {
              account: '', //  string  账号 必需 邮箱或手机号
              code: '' //  string  验证码 必需
            }
            this.setForm = {
              password: '', //  string  新密码
              ConfirmPassword: '' // string 确认密码
            }
          }
        }
      })
    },
    // 倒计时
    countDown () {
      this.isCode = true
      let time = null
      time = setInterval(() => {
        if (this.num <= 0) {
          this.isCode = false
          this.num = 59
          clearInterval(time)
          return
        }
        this.num--
      }, 1000)
    },
    // 确认提示
    confirm () {
      this.isConfirmation = false
      this.$store.commit('login/setSign', 1)
    },
    // 获取路径参数
    getlocation () {
      if (!/code/.test(window.location.search) || this.$store.state.token) {
        return
      }
      let url = window.location.search.split('?')[1]
      url = url.split('&')
      let code = null
      url.forEach((item) => {
        if (/code/.test(item)) {
          code = item.split('=')[1]
        }
      })
      this.wxLogin(code)
    },
    // 获取用户名称
    async getUserName () {
      const { data } = await chatGetUserName({
        account: this.retForm.account
      })
      this.setForm.username = data.username
    }
  },
  watch: {
    isShow (val) {
      // 恢复默认数据
      if (!val) {
        this.regForm = {
          username: '',
          password: ''
        }
        this.signForm = {
          username: '',
          password: ''
        }
        this.retForm = {
          account: ''
        }
        this.setForm = {
          code: '',
          password: '',
          ConfirmPassword: ''
        }
      }
    },
    sign (val) {
      switch (val) {
        case 1:
          this.$nextTick(() => {
            this.$refs.signForm.clearValidate()
          })
          break
        case 2:
          this.$nextTick(() => {
            this.$refs.regForm.clearValidate()
          })
          break

        default:
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./login.less");
</style>
